import React from "react";
import arrow from "../../images/Assets/arrow.png";

export default function Footer() {
  return (
    <div className="md:px-6 xl:px-10 px-28 py-16">
      <div className="bg-[#7846F0] rounded-[30px] px-7 pt-6 pb-7">
        <div className="flex lg:flex-col flex-row lg:items-center items-end justify-between gap-7">
          <div className="text-start">
            <div className="xl:text-[28px] text-[40px] text-[#FFFFFF] font-gilroySemibold">
              Book a free consultation
            </div>

            <div className="xl:text-[16px] text-[17px] text-[#FFFFFF] opacity-80 font-gilroyRegular md:mt-4 mt-0">
              Ready to bring your vision to life with AI? We’re here to help. Get in touch with us today for a
              free consultation, and let's explore how Komodo AI can help you{" "}
              <br className="2xl:hidden block" /> build the future.
            </div>
          </div>

          <img src={arrow} alt="arrow" className="mb-5" />

          <div className="text-[16px] text-[#7846F0] font-gilroySemibold bg-[#FFFFFF] lg:w-full w-fit text-nowrap text-center py-2 xl:px-4 px-10 rounded-full cursor-pointer">
            Book a free call
          </div>
        </div>
      </div>
    </div>
  );
}
